module.exports = __webpack_public_path__ + "img/Middle-Semi-Elliptical-Attachment-R-33.27779af1.png";